export default __webpack_public_path__ + "static/media/minichat.c6b1c192.png";